import type React from 'react';
import type { ShopTheme } from '../theme';

/** The shop's text input look: paper surface, hairline border, venue radius. */
export function inputStyle(theme: ShopTheme, invalid = false): React.CSSProperties {
  return {
    width: '100%',
    boxSizing: 'border-box',
    padding: '13px 14px',
    background: theme.surface,
    border: `1px solid ${invalid ? theme.accent : theme.inputBorder}`,
    borderRadius: theme.radius,
    font: `400 16px/1.4 ${theme.fontFamily}`,
    color: theme.ink,
    outline: 'none',
  };
}
